(() => {
  const buttonSelector = '.wishlist-hero-list-card-footer-add-to-cart';
  const bulkSelector = '.wishlist-hero-list-card-footer-add-all-to-cart-dialog';
  const states = new WeakMap();
  const requests = new Map();
  const productUrl = (button) => {
    const card = button.closest('.MuiPaper-root');
    const link = card?.querySelector('a[href*="/products/"]');
    if (!link) return null;
    const url = new URL(link.getAttribute('href'), window.location.origin);
    if (url.origin !== window.location.origin || !url.pathname.includes('/products/')) return null;
    url.searchParams.delete('section_id');
    return url;
  };
  const statusFor = (url) => {
    const key = url.href;
    const cached = requests.get(key);
    if (cached && Date.now() - cached.time < 5000) return cached.promise;
    const statusUrl = new URL(key);
    statusUrl.searchParams.set('section_id', 'sova-purchase-state');
    const promise = fetch(statusUrl.href, { cache: 'no-store' })
      .then((response) => {
        if (!response.ok) throw new Error('Purchase status unavailable');
        return response.text();
      }).then((html) => {
        const element = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-sova-purchase-state]');
        if (!element) throw new Error('Purchase status missing');
        const state = JSON.parse(element.textContent);
        if (typeof state.preorder !== 'boolean' || typeof state.purchasable !== 'boolean') throw new Error('Invalid purchase status');
        const variant = url.searchParams.get('variant');
        if (variant && String(state.variantId) !== variant) throw new Error('Variant status mismatch');
        return state;
      });
    requests.set(key, { time: Date.now(), promise });
    promise.catch(() => { if (requests.get(key)?.promise === promise) requests.delete(key); });
    if (requests.size > 100) requests.delete(requests.keys().next().value);
    return promise;
  };
  const scan = () => {
    document.querySelectorAll(buttonSelector).forEach((button) => {
      const url = productUrl(button);
      if (!url) {
        button.disabled = true;
        button.title = 'Откройте страницу товара для проверки наличия';
        return;
      }
      const previous = states.get(button);
      if (previous?.url === url.href) {
        if (previous.state) apply(button, previous.state);
        return;
      }
      const entry = { url: url.href, state: null };
      states.set(button, entry);
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      statusFor(url).then((state) => {
        if (states.get(button) !== entry || !button.isConnected) return;
        entry.state = state;
        button.removeAttribute('aria-busy');
        apply(button, state);
      }).catch(() => {
        if (states.get(button) !== entry || !button.isConnected) return;
        button.removeAttribute('aria-busy');
        button.disabled = true;
        button.title = 'Не удалось проверить товар. Откройте его страницу';
      });
    });
  };
  const apply = (button, state) => {
    const label = button.querySelector('.MuiButton-label') || button;
    if (label.textContent.trim() !== state.label) label.textContent = state.label;
    if (button.disabled !== !state.purchasable) button.disabled = !state.purchasable;
    button.classList.toggle('Mui-disabled', !state.purchasable);
  };
  document.addEventListener('click', (event) => {
    const target = event.target.closest?.(`${buttonSelector}, ${bulkSelector}`);
    if (!target) return;
    const buttons = target.matches(bulkSelector) ? Array.from(document.querySelectorAll(buttonSelector)) : [target];
    const unsafe = buttons.find((button) => {
      const entry = states.get(button);
      return !entry?.state || entry.state.preorder || !entry.state.purchasable;
    });
    if (!unsafe) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const url = productUrl(unsafe);
    if (url) window.location.assign(url.href);
  }, true);
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; scan(); });
  }).observe(document.body, { childList: true, subtree: true });
  scan();
})();
